import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconVideo2Off: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconVideo2Off"><Path d="M2.5 2.5L17.5 21.5" stroke="currentColor" strokeWidth="1.5"/><Path d="M13.6914 19.5H2V4.69043L13.6914 19.5ZM17.5 18.6748L6.30859 4.5H17.5V18.6748ZM22.5 17.6074L21.4717 17.1963L18.9717 16.1963L18.5 16.0078V7.99219L18.9717 7.80371L21.4717 6.80371L22.5 6.39258V17.6074Z" fill="currentColor"/></CentralIconBase>;
});

export default IconVideo2Off;
